import { useEffect, useState } from 'react';
import { prefersReducedMotion } from './media';

const TICK_MS = 18;
const CHARS_PER_TICK = 2;

export function useTypewriter(text: string, enabled: boolean) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled) return undefined;
    setCount(0);
    if (prefersReducedMotion()) {
      setCount(text.length);
      return undefined;
    }
    let next = 0;
    const timer = setInterval(() => {
      next = Math.min(next + CHARS_PER_TICK, text.length);
      setCount(next);
      if (next >= text.length) clearInterval(timer);
    }, TICK_MS);
    return () => clearInterval(timer);
  }, [text, enabled]);

  return {
    count: enabled ? count : 0,
    isTyping: enabled && count < text.length,
    isDone: enabled && count >= text.length,
  };
}
